import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg, NodeSocketKindMap } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec, RequiredSockets } from './NodeSpec';

export const activeOperatorUiNodeSpec: NodeSpec<NodeCfg<'activeOperator'>> = {
    cfg: () => ({ id: getUID(), kind: 'activeOperator', width: 210 }),
    controls: () => ({}),
    inputs: () => ({}),
    kindLabel: 'Active Operator',
    nodeCategory: 'events',
    outputs: () => ({
        loggedIn: { socket: 'event', label: 'Logged In' },
        loggedOut: { socket: 'event', label: 'Logged Out' },
        username: { socket: 'string', label: 'Username' },
        firstName: { socket: 'string', label: 'First Name' },
        lastName: { socket: 'string', label: 'Last Name' },
    }),
    requiredSockets: (): ReturnType<RequiredSockets<'activeOperator', NodeSocketKindMap['activeOperator']>> => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: [ 'username', 'firstName', 'lastName' ],
            },
        ],
    }),
    validator: () => true,
};
